
import { Component, effect, ElementRef, input, viewChild } from '@angular/core';

@Component({
    selector: 'abc-qrcode-viewer',
    template: `<canvas #canvas [style.width]="width()" [style.height]="height()"></canvas>`,
    styles: ``,
    imports: []
})
export class AbcQrCodeViewerComponent {
  public canvas = viewChild<ElementRef<HTMLCanvasElement>>('canvas');
  public qrData = input<string>();
  public width = input<string>('100px');
  public height = input<string>('100px');
  public color = input<string>('var(--PrimaryMainColor)');

  constructor() {
    effect(() => {
      const canvasElement = this.canvas()?.nativeElement;
      if (!canvasElement || !this.qrData()) return;

      const ctx = canvasElement.getContext('2d')!;
      const img = new Image();

      img.crossOrigin = 'anonymous';

      img.onload = () => {
        canvasElement.width = img.width;
        canvasElement.height = img.height;
        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvasElement.width, canvasElement.height);
        const data = imageData.data;

        const [rNew, gNew, bNew] = this.resolveCssColor(this.color(), canvasElement);

        for (let i = 0; i < data.length; i += 4) {
          const r = data[i],
            g = data[i + 1],
            b = data[i + 2];
          const isDark = r < 100 && g < 100 && b < 100;

          if (isDark) {
            data[i] = rNew;
            data[i + 1] = gNew;
            data[i + 2] = bNew;
          } else {
            data[i] = 255;
            data[i + 1] = 255;
            data[i + 2] = 255;
          }
        }
        ctx.putImageData(imageData, 0, 0);
      };

      img.src = this.qrData();
    });
  }

  private resolveCssColor(cssValue: string, el: HTMLElement): [number, number, number] {
    const temp = document.createElement('div');
    temp.style.color = cssValue;
    el.appendChild(temp);
    const computed = getComputedStyle(temp).color;
    el.removeChild(temp);

    const match = computed.match(/\d+/g);
    if (!match) return [0, 0, 0];
    return [parseInt(match[0]), parseInt(match[1]), parseInt(match[2])];
  }
}
